import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import user from './user/reducers'
import menu from './menu/reducers'
import settings from './settings/reducers'
import apps from './apps/reducers'
import plans from './plans/reducers'
import billingHistory from './billingHistory/reducers'
import ai from './ai/reducers'
import roles from './roles/reducers'
import teams from './teams/reducers'
import extensions from './extensions/reducers'
import billing from './billing/reducers'
import calls from './calls/reducers'
import apiKeys from './apiKeys/reducers'
import webhooks from './webhooks/reducers'
import users from './users/reducers'
import messages from './messages/reducers'
import groups from './groups/reducers'
import misc from './misc/reducers'
import widgets from './widgets/reducers'
import metrics from './metrics/reducers'
import moderation from './moderation/reducers'
import aiAgents from './aiAgents/reducers'
import customBots from './customBots/reducers'
import appCore from './appCore/reducers'
import conversationExplorer from './conversationExplorer/reducers'
import pinnedConversations from './pinnedConversations/reducers'

export default history =>
  combineReducers({
    router: connectRouter(history),
    settings,
    user,
    menu,
    apps,
    plans,
    billingHistory,
    ai,
    roles,
    teams,
    extensions,
    billing,
    calls,
    apiKeys,
    webhooks,
    users,
    messages,
    groups,
    misc,
    widgets,
    metrics,
    moderation,
    aiAgents,
    customBots,
    appCore,
    conversationExplorer,
    pinnedConversations,
  })
